import { squadMixin } from "@mixin/squad";
export default {
  name: "pageSquad",
  mixins: [squadMixin]
};